import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS } from "utils/status";
import api from "api";

interface Document {
  url: string;
}

interface UploadState {
  file: string;
  fileUploadStatus: string;
  fileUploadError: string;
  documents: { [configId: string]: Document };
}

const initialState: UploadState = {
  file: '',
  fileUploadStatus: STATUS.NOT_STARTED,
  fileUploadError: '',
  documents: {}
};

interface LatexPayload {
  latex: string;
  alloc_id: string;
  config_id: string;
}

export const latexAction = createAsyncThunk(
  "process/latex",
  async (payload: LatexPayload) => {
    const response = await api.post('process/latex/', payload);
    const data = response.data;
    return { ...data, config_id: payload.config_id };
  }
);

const latexCodeSlice = createSlice({
  name: 'latex',
  initialState,
  reducers: {
    setfileUploadStatus: (state, action) => {
      state.fileUploadStatus = action.payload;
    },
    clearLatexState: (state) => {
      state.file = '';
      state.fileUploadStatus = STATUS.NOT_STARTED;
      state.fileUploadError = '';
      state.documents = {};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(latexAction.pending, (state) => {
      state.fileUploadStatus = STATUS.PENDING;
    });

    builder.addCase(latexAction.fulfilled, (state, action) => {
      const { config_id, url } = action.payload;
      state.documents[config_id] = { url };
      state.fileUploadStatus = STATUS.SUCCESS;
    });

    builder.addCase(latexAction.rejected, (state, action) => {
      state.fileUploadError = action.error.message ?? "Unknown error";
      state.fileUploadStatus = STATUS.FAILED;
    });
  }
});

export const { setfileUploadStatus, clearLatexState } = latexCodeSlice.actions;

export default latexCodeSlice.reducer;



